import { CheckCircle, OctagonX } from 'lucide-react';

type StatusValueProps = {
  value: boolean;
};

export function StatusValue(props: StatusValueProps) {
  const { value } = props;

  if (value) return <CheckCircle className="h-5 w-5 text-green-700" />;

  return <OctagonX className="h-5 w-5 text-red-600" />;
}
